import React, { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { CoreContext } from "context/CoreContext";
import { DoLogout } from "services/authentication";

import {
    BottomBar,
    Tab,
    TabIcon,
    TabLabel,
    Avatar,
    CenterTab,
    CenterCircle,
    Overlay,
    ProfilePopup,
    PopupProfile,
    PopupProfileImage,
    PopupOption
} from "./styled";

// ─────────────────────────────────────────────────────────────────────────────
// ÍCONES (desenhados aqui dentro para herdarem a cor do texto — branco/rosa).
// ─────────────────────────────────────────────────────────────────────────────
const IconSearch = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <circle cx="11" cy="11" r="7" />
        <line x1="16.5" y1="16.5" x2="21" y2="21" />
    </svg>
);

const IconHome = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 3.2 2.5 11h2.6v9h4.6v-5.6h4.6V20h4.6v-9h2.6L12 3.2z" />
    </svg>
);

const IconHeart = () => (
    <svg viewBox="0 0 21.526 19.135" fill="currentColor">
        <path d="M13.763,8.588A5.9,5.9,0,0,0,8.382,5,5.278,5.278,0,0,0,3,10.382c0,4.22,4.536,7.484,10.763,13.753C19.99,17.866,24.526,14.6,24.526,10.382A5.278,5.278,0,0,0,19.145,5,5.9,5.9,0,0,0,13.763,8.588Z" transform="translate(-3 -5)" fillRule="evenodd" />
    </svg>
);

const IconActivities = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 9V4h12v5" />
        <rect x="6.5" y="13.5" width="11" height="6.5" rx="1" />
        <path d="M6 17H4a1 1 0 0 1-1-1v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1h-2" />
    </svg>
);

export default function DashboardBottomNav(){
    const history = useHistory();
    const location = useLocation();
    const navigate = to => history.push(`/${ to }`);

    const { currentProfile, profiles, setCurrentProfile, setProfiles } = useContext(CoreContext);
    const [ profileOpen, setProfileOpen ] = useState(false);

    const path = location?.pathname || '';
    const isActive = base => path === base || path.indexOf(`${ base }/`) === 0;
    const isHome = path === '/dashboard';

    const go = to => { setProfileOpen(false); navigate(to); };

    const selectProfile = item => {
        setCurrentProfile(item);
        setProfileOpen(false);
    };

    const exit = async () => {
        setProfiles([]);
        setCurrentProfile(null);
        await DoLogout();
        navigate('login');
    };

    return (
        <>
            { profileOpen ? <Overlay onClick={() => setProfileOpen(false)} /> : null }

            { profileOpen ?
                <ProfilePopup>
                    {
                        profiles?.filter(fit => fit.id !== currentProfile?.id)?.slice(0, 2).map((item, key) =>
                            <PopupProfile key={key} onClick={() => selectProfile(item)}>
                                <PopupProfileImage image={item.avatar?.image} />
                                { item.name }
                            </PopupProfile>
                        )
                    }
                    <PopupOption onClick={() => go('dashboard/select-profile')}>Gerenciar perfis</PopupOption>
                    <PopupOption onClick={() => go('dashboard/account')}>Minha conta</PopupOption>
                    <PopupOption onClick={() => go('dashboard/help')}>Ajuda</PopupOption>
                    <PopupOption onClick={() => go('dashboard/about')}>Sobre</PopupOption>
                    <PopupOption danger onClick={exit}>Sair</PopupOption>
                </ProfilePopup>
            : null }

            <BottomBar>
                <Tab active={profileOpen} onClick={() => setProfileOpen(!profileOpen)}>
                    <Avatar image={ currentProfile?.avatar?.image ? currentProfile?.avatar?.image : '/images/users/face.png' } />
                    <TabLabel>Perfil</TabLabel>
                </Tab>

                <Tab active={isActive('/dashboard/search')} onClick={() => go('dashboard/search')}>
                    <TabIcon><IconSearch /></TabIcon>
                    <TabLabel>Pesquisar</TabLabel>
                </Tab>

                <CenterTab onClick={() => go('dashboard')}>
                    <CenterCircle><IconHome /></CenterCircle>
                    <TabLabel style={{ fontWeight: isHome ? 700 : 400 }}>Início</TabLabel>
                </CenterTab>

                <Tab active={isActive('/dashboard/favorites')} onClick={() => go('dashboard/favorites')}>
                    <TabIcon><IconHeart /></TabIcon>
                    <TabLabel>Favoritos</TabLabel>
                </Tab>

                <Tab active={isActive('/dashboard/downloads')} onClick={() => go('dashboard/downloads')}>
                    <TabIcon><IconActivities /></TabIcon>
                    <TabLabel>Atividades</TabLabel>
                </Tab>
            </BottomBar>
        </>
    );
}
